module.exports = __webpack_public_path__ + "front/img/83_2.ef893e0e.png";